import React, { useState, useEffect, useRef } from "react"
import { Col, Container, Row } from "react-bootstrap"
import { DataTable } from "primereact/datatable"
import { FilterMatchMode } from "primereact/api"
import { Column } from "primereact/column"
import { Button } from "primereact/button"
import { SelectButton } from "primereact/selectbutton"
import { ReportSourceApi } from "utils/ApiClients"
import { useDispatch, useSelector } from "react-redux"
import { setPageData } from "store/actions"
import CompanySelector from "ATSComponents/Common/CompanySelector"
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer"

const RecruiterPerformanceReport = () => {
  // const dispatch = useDispatch()
  // const { first, rows, totalRecords } = useSelector(
  //   state => state.calendar.pagination
  // )

  const [first, setFirst] = useState(0);

  const [rows, setRows] = useState(10);

  const [totalRecords, setTotalRecords] = useState(0);

  const userInfos = JSON.parse(sessionStorage.getItem("user-info"));
  const intialcompanyId = userInfos.user_details.companies_data[0].company_id;
  const [companyId, setCompanyId] = useState(intialcompanyId);

  // const handleCompanyChange = (company) => {
  //   if (company?.company_id) {
  //     const selectedId = company.company_id;
  //     setCompanyId(selectedId);

  //     const page = Math.floor(first / rows) + 1;
  //     fetchRecruiterReportsData(page, selectedId);
  //   }
  // };

  const handleCompanyChange = (item) => {

    if (item?.company_id) {

      setCompanyId(item.company_id);

      setFirst(0); // reset pagination

    }

  };

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  })
  const [columns, setColumns] = useState([])
  const [recruiterData, setRecruiterData] = useState([])
  const [selectedRecruiterData, setSelectedRecruiterData] = useState([])
  const [loading, setLoading] = useState(true)
  const dt = useRef(null)
  document.title = "ATS - Reports"
  const [sizeOptions] = useState([
    { label: "Small", value: "small" },
    { label: "Normal", value: "normal" },
    { label: "Large", value: "large" },
  ])
  const [size, setSize] = useState(sizeOptions[1].value)

  const generateColumnsAndFilters = data => {
    if (!data || data.length === 0) return { columns: [], filters: {} }

    const sampleRow = data[0]
    const columns = Object.keys(sampleRow).map(field => ({
      field,
      header: field.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase()),
      filterPlaceholder: `${field.replace(/_/g, " ")}`,
    }))

    const newFilters = Object.keys(sampleRow).reduce(
      (acc, field) => ({
        ...acc,
       [field]: { value: null, matchMode: FilterMatchMode.CONTAINS }

      }),
      { global: { value: null, matchMode: FilterMatchMode.CONTAINS } }
    )

    return { columns, filters: newFilters }
  }

  const exportCSV = () => {
    const dataToExport =
      selectedRecruiterData.length > 0 ? selectedRecruiterData : recruiterData
    if (selectedRecruiterData.length > 0) {
      dt.current.exportCSV({ selectionOnly: true })
    } else {
      dt.current.exportCSV()
    }
  }

  const exportPdf = () => {
    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(() => {
        const dataToExport =
          selectedRecruiterData.length > 0
            ? selectedRecruiterData
            : recruiterData

        if (dataToExport.length === 0) {
          alert("No data available for export.")
          return
        }

        const doc = new jsPDF.default("landscape")
        const exportColumns = columns.map(({ field, header }) => ({
          title: field === "user_id" ? "User" : header,
          dataKey: field,
        }))

        const formattedData = dataToExport.map(row => {
          const formattedRow = {}
          columns.forEach(({ field }) => {
            formattedRow[field] = row[field] ?? ""
          })
          return formattedRow
        })

        doc.autoTable({
          columns: exportColumns,
          body: formattedData,
          startY: 20,
          styles: { fontSize: 8, cellPadding: 2 },
          theme: "grid",
          margin: { top: 10, left: 5, right: 5 },
          columnStyles: { 0: { cellWidth: 30 } },
        })

        doc.save("recruiter-performance-report.pdf")
      })
    })
  }

  const exportExcel = () => {
    import("xlsx").then(xlsx => {
      const dataToExport =
        selectedRecruiterData.length > 0 ? selectedRecruiterData : recruiterData
      const formattedData = dataToExport.map(row => {
        const formattedRow = {}
        columns.forEach(({ field, header }) => {
          formattedRow[field === "user_id" ? "User" : header] = row[field] ?? ""
        })
        return formattedRow
      })

      const worksheet = xlsx.utils.json_to_sheet(
        formattedData.length > 0
          ? formattedData
          : [{ message: "No data to export" }]
      )
      const headers = columns.map(col =>
        col.field === "user_id" ? "User" : col.header
      )
      xlsx.utils.sheet_add_aoa(worksheet, [headers], { origin: "A1" })

      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] }
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      })
      saveAsExcelFile(excelBuffer, "recruiter-performance-report")
    })
  }

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then(module => {
      if (module && module.default) {
        const EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
        const EXCEL_EXTENSION = ".xlsx"
        const data = new Blob([buffer], { type: EXCEL_TYPE })
        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        )
      }
    })
  }

  const printFile = () => {
    const dataToPrint =
      selectedRecruiterData.length > 0 ? selectedRecruiterData : recruiterData
    const exportColumns = columns.map(({ field, header }) => ({
      title: header,
      dataKey: field,
    }))

    const tableHeaders = exportColumns
      .map(
        col =>
          `<th style="border: 1px solid #ccc; padding: 8px;">${col.title}</th>`
      )
      .join("")

    const tableRows =
      dataToPrint.length > 0
        ? dataToPrint
          .map(row => {
            return `<tr>${exportColumns
              .map(
                col =>
                  `<td style="border: 1px solid #ccc; padding: 8px;">${row[col.dataKey] ?? ""
                  }</td>`
              )
              .join("")}</tr>`
          })
          .join("")
        : `<tr><td colspan="${exportColumns.length}" style="border: 1px solid #ccc; padding: 8px; text-align: center;">No data to print</td></tr>`

    const htmlContent = `
      <html>
      <head>
        <title>Print Recruiter Report</title>
        <style>
          table { border-collapse: collapse; width: 100%; margin-top: 20px; }
          th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
          th { background-color: #f2f2f2; }
          h2 { text-align: center; }
        </style>
      </head>
      <body>
        <h2>Recruiter Performance Report</h2>
        <table>
          <thead><tr>${tableHeaders}</tr></thead>
          <tbody>${tableRows}</tbody>
        </table>
      </body>
      </html>
    `

    const printWindow = window.open("", "", "height=600,width=900")
    printWindow.document.write(htmlContent)
    printWindow.document.close()
    printWindow.focus()
    printWindow.print()
    printWindow.close()
  }

  // const fetchRecruiterReportsData = async page => {
  //   try {
  //     const response = await ReportSourceApi(
  //       `/performance_report/?page=${page}&size=${rows}`
  //     )
  const fetchRecruiterReportsData = async (page,size = 10, companyId) => {
    setLoading(true);
    try {
      const response = await ReportSourceApi(
        `/performance_report/?page=${page}&size=${size}&company_id=${companyId}`
      )
      if (response.status === 200) {
        const data = response?.data?.results || []
        setLoading(false);
        setRecruiterData(data)
        // console.info(data ,"data from recuitor report")
        const { columns: newCols, filters: newFilters } =
          generateColumnsAndFilters(data)
        setColumns(newCols)
        setFilters(prevFilters => ({ ...prevFilters, ...newFilters }))
        setTotalRecords(response?.data?.count || 0);
        //   dispatch(
        //     setPageData({
        //       first: (page - 1) * rows,
        //       rows: rows || 10,
        //       totalRecords: response?.data?.count || 0,
        //     })
        //   )
      }
    } catch (err) {
      console.error("Error fetching data:", err.message)
      setLoading(false);
    }
  }

  // useEffect(() => {
  //   const page = Math.floor(first / rows) + 1
  //   fetchRecruiterReportsData(page)
  // }, [first, rows])


  // useEffect(() => {
  //   if (companyId) {
  //     const page = Math.floor(first / rows) + 1;
  //     fetchRecruiterReportsData(page, companyId);
  //   }
  // }, [first, rows, companyId]);


  const [pageSize, setPageSize] = useState(5);
  useEffect(() => {
    if (companyId) {
      const page = Math.floor(first / rows) + 1;
      fetchRecruiterReportsData(page,10, companyId);
    }

  }, [companyId,pageSize]);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: 1,
  });

  const handlePageChange = (event) => {
    const { first, rows } = event;
    const page = Math.floor(first / rows) + 1;
    setLazyParams({ first, rows, page });
    fetchRecruiterReportsData( page,rows, companyId);
  };

  const onPage = (e) => {

    setFirst(e.first);

    setRows(e.rows);

  };
  // const onPage = e => {
  //   const newPage = Math.floor(e.first / e.rows) + 1
  //   dispatch(
  //     setPageData({
  //       first: e.first,
  //       rows: e.rows,
  //       totalRecords,
  //     })
  //   )
  //   fetchRecruiterReportsData(newPage)
  // }

  return (
    <React.Fragment>
      <style>
        {`
          /* Override PrimeReact DataTable font sizes for small mode */
          /* Override PrimeReact DataTable font sizes for small mode */
.p-datatable.p-datatable-sm .p-datatable-thead > tr > th,
.p-datatable.p-datatable-sm .p-datatable-tbody > tr > td,
.p-datatable.p-datatable-sm .p-datatable-header,
.p-datatable.p-datatable-sm .p-datatable-footer,
.p-datatable.p-datatable-sm .p-column-header-content,
.p-datatable.p-datatable-sm .p-filter-column .p-column-filter,
.p-datatable.p-datatable-sm .p-paginator {
  font-size: 0.8rem !important; /* Smaller font for small mode */
}

/* Override PrimeReact DataTable font sizes for normal mode */
.p-datatable.p-datatable-md .p-datatable-thead > tr > th,
.p-datatable.p-datatable-md .p-datatable-tbody > tr > td,
.p-datatable.p-datatable-md .p-datatable-header,
.p-datatable.p-datatable-md .p-datatable-footer,
.p-datatable.p-datatable-md .p-column-header-content,
.p-datatable.p-datatable-md .p-filter-column .p-column-filter,
.p-datatable.p-datatable-md .p-paginator {
  font-size: 1rem !important; /* Standard font for normal mode */
}

/* Override PrimeReact DataTable font sizes for large mode */
.p-datatable.p-datatable-lg .p-datatable-thead > tr > th,
.p-datatable.p-datatable-lg .p-datatable-tbody > tr > td,
.p-datatable.p-datatable-lg .p-datatable-header,
.p-datatable.p-datatable-lg .p-datatable-footer,
.p-datatable.p-datatable-lg .p-column-header-content,
.p-datatable.p-datatable-lg .p-filter-column .p-column-filter,
.p-datatable.p-datatable-lg .p-datatable-thead > tr > th {
  font-size: 1.3rem !important; /* Larger font for headers in large mode */
}

/* Ensure SelectButton font size remains consistent */
.sizebtns .p-selectbutton .p-button {
  font-size: 1rem !important; /* Keep SelectButton font size unchanged */
}
        `}
      </style>
      <div className="page-content allact-tabs">
        <Container fluid={true}>
          <div className="page-title-box actjobbread mb-0">

            <Row className="align-items-center actjobsum">
              <Col sm={6} md={6} lg={8}>
                <h1 className="page-title">Recruiter Performance Report</h1>
              </Col>
              <Col sm={6} md={6} lg={4}>
                <div className="d-flex justify-content-end gap-2">
                  <div className="allbtns d-flex gap-2 justify-content-end">
                    <Button
                      icon="pi pi-file"
                      rounded
                      onClick={exportCSV}
                      tooltip="Export to CSV"
                      tooltipOptions={{ position: "left" }}
                      className="csvbtn"
                    />
                    <Button
                      icon="pi pi-file-excel"
                      severity="success"
                      rounded
                      onClick={exportExcel}
                      tooltip="Export to XLS"
                      tooltipOptions={{ position: "top" }}
                      className="xlsbtn"
                    />
                    <Button
                      icon="pi pi-file-pdf"
                      severity="warning"
                      rounded
                      onClick={exportPdf}
                      tooltip="Export to PDF"
                      tooltipOptions={{ position: "bottom" }}
                      className="pdfbtn"
                    />
                    <Button
                      icon="pi pi-print"
                      severity="warning"
                      rounded
                      tooltip="Print"
                      tooltipOptions={{ position: "bottom" }}
                      className="printbtn"
                      onClick={printFile}
                    />
                  </div>
                  <div className="flex justify-content-end mb-2 sizebtns">
                    <SelectButton
                      value={size}
                      onChange={e => setSize(e.value)}
                      options={sizeOptions}
                    />
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col xxl={6}>
                <h1 className="page-title mb-4"> </h1>
              </Col>
              <Col xxl={6}>
                <div className="d-flex justify-content-end">
                  <label className="mt-2 me-2">Select Company</label>
                  <div className="mb-2 me-2" style={{ width: "170px" }}>
                    <CompanySelector onCompanyChange={handleCompanyChange} />
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <section className="job-datatable-section">
                  <div className="card1 mt-3 mb-4 actjobsumtable">
                    {loading ? (
                        <OrgTableShimmer columns={6} rows={7} titleWidth="220px" />
                      ) : (
                      <DataTable
                        ref={dt}
                        value={recruiterData}
                        tableStyle={{ minWidth: "50rem" }}
                        totalRecords={totalRecords}

                        paginator
                        rowsPerPageOptions={[10, 20, 50, totalRecords]}

                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                        onPage={handlePageChange}
                        first={lazyParams.first}
                        scrollable
                        scrollHeight="500px"
                        rows={lazyParams.rows}
                        // lazy
                        //  rows={rows}
                          // first={first}
                          // onPage={onPage}
                          // totalRecords={totalRecords}
                          filters={filters}
                          filterDisplay="row"
                        dataKey="user_id"
                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        loading={loading}
                        emptyMessage="No records found."
                        selection={selectedRecruiterData}
                        onSelectionChange={e => setSelectedRecruiterData(e.value || [])}
                        selectionMode="multiple"
                        // filters={filters}
                        // filterDisplay="row"
                        reorderableRows
                        resizableColumns
                        id="RecruiterPerformanceReport"
                        columnResizeMode="expand"
                        size={size}
                        className={`p-datatable-${size}`}
                      >

                        {columns
                          .filter(col => col.field !== "user_id")
                          .map((col, index) => (
                            <Column
                              key={index}
                              field={col.field}
                              header={col.field === "email" ? "Recruiter" : col.header}
                              sortable
                              filter
                              filterPlaceholder={col.field === "email" ? "Recruiter" : col.filterPlaceholder}
                              style={{ width: "10rem" }}
                              bodyStyle={{ width: "10rem" }}
                            />
                          ))}
                      </DataTable>
                    )}
                  </div>
                </section>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default RecruiterPerformanceReport
